
import 'jquery';
import 'bootstrap/js/dist/dropdown';

import { Utils } from "../include/utils";

import '../../librerias/modernizr/modernizr-custom.js';
import { Forms } from '../include/forms';

import '../../librerias/analitycs_alk/analitycs_alk.js'
import { TagManager } from '../include/tagManager';

declare var grecaptcha: any;
declare var $respond: any;

declare var _aceptar_cookies: boolean;

/**
 * Clase para gestionar la configuracion de un campo autocomplete
 */
export class PageAbstract {

    utils = new Utils();
    tagManager: TagManager;

    /** constructor */
    constructor() {
        this.tagManager = new TagManager(this.utils);

        this.listenChangeCurrency();
        this.listenLogin();
        this.submitRegistrarUsuario();
        this.showModalRegistrate();
        this.showModalForgot();
        this.ForgotListen();
        this.listeLogOut();
        this.listeButtonUp();
        this.listenCookies();
        this.listenGetLinkAlq();
        this.listenChat();
        this.fixImgError();

        $('body').one('show.bs.dropdown', () => {
            /** Cargamos la libreria de capcha */
            import("scriptjs").then((module) => {
                const $script = module.default;
                $script("https://www.google.com/recaptcha/api.js", null!);
            });
        });

        $('#domain').on('change', function () {
            window.location.href = $(this).val()?.toString() || '/';
        });

        $('#close-banner-promo').on('click', function () {
            $(this).parent().remove();
        });
    }

    fixImgError() {
        $('img').on('error', function () {
            $(this).attr('src', 'https://alktesters1.s3.amazonaws.com/40-35/0-0-tn3-NoImageApp.jpg');
        });
    }

    listenChat(time = 0) {
        if (typeof $respond !== 'undefined') {
            $respond.on('chat:sent', () => {
                this.tagManager.eventItemOnly('event_click_chat');
            });
        } else {
            if (time < 5) setTimeout(() => this.listenChat(time + 1), 100);
        }
    }

    listeButtonUp() {
        $(".top-ico").click(function () {
            $('html,body').animate({ scrollTop: 0 }, 200);
        });
    }

    listeLogOut() {
        let self = this;
        $(document).on('click', 'a[href="/logout/"]', function (event) {
            event.stopPropagation();
            event.preventDefault();
            let config = { dir: '/action/logout/', type: 'POST' }
            self.utils.eraseCookie('__tawkuuid', Domain);
            self.utils.jSONInfo(config, {}, function (data: any) {
                location.reload();
            });
        });
    }

    /**
     * Listener para abrir el modal de registrate
     */
    showModalRegistrate() {
        $("#btn-modal-registrate").on("click", function (event: any) {
            let modal = $('#modal-registrate');
            modal.modal().modal('show');
        });
    }

    showModalForgot() {
        $("#btn-forgot").on("click", function (event: any) {
            let modal = $('#modal-forgot');
            modal.modal().modal('show');
        });
    }

    parseParams(query: string) {
        var re = /([^&=]+)=?([^&]*)/g;
        var decode = function (str: string) {
            return decodeURIComponent(str.replace(/\+/g, ' '));
        };
        var params: any = {}, e;
        if (query) {
            if (query.substr(0, 1) == '?') {
                query = query.substr(1);
            }

            while (e = re.exec(query)) {
                var k = decode(e[1]);
                var v = decode(e[2]);
                if (params[k] !== undefined) {
                    if (!$.isArray(params[k])) {
                        params[k] = [params[k]];
                    }
                    params[k].push(v);
                } else {
                    params[k] = v;
                }
            }
        }
        return params;
    };


    listenChangeCurrency() {
        let self = this;
        $(document).on('click', 'span.currency', 'click', function (event) {
            var currency = $(this).attr('data-value'), varName = 'currency';

            console.log('varName', varName);
            console.log('currency', currency);
            console.log('Domain', Domain);

            self.utils.createCookie(varName, currency, 30, Domain)

            let urlParams = self.parseParams(window.location.search);
            if (urlParams.currency != undefined) {
                urlParams.currency = currency;
                window.location.assign('?' + $.param(urlParams))
            }
            else {
                window.location.reload()
            }

        });
    }

    listenLogin() {
        let self = this;
        $(document).on('submit', '#form-login, #form-login-error, #form-login-modal', function (event) {
            event.stopPropagation();
            event.preventDefault();
            let args = {
                alias: $(this).find('[name="alias"]').val(),
                password: $(this).find('[name="password"]').val(),
                code_2fa: $(this).find('[name="code_2fa"]').val()
            }
                , config = { dir: '/action/login/', type: 'POST' }
                , $form = $(this)

            let $btn_accion = $form.find('#btn-login');

            self.addLoadingButton($btn_accion)

            self.utils.jSONInfo(config, args, function (data: any) {
                if (data.ans?.error === 10 || data.ans?.errSTR === "Auth 2FA") {
                    $("#code_2fa").removeClass("d-none");
                }
                setTimeout(function () {
                    self.removeLoadingButton($btn_accion)
                }, 300)
                self.utils.afterSubmit(data, $form.attr('id'), false)
            });
        });
    }

    listenGetLinkAlq() {
        let self = this;
        $(document).on('submit', '#form-get-link-alq', function (this: HTMLFormElement, event) {
            event.stopPropagation();
            event.preventDefault();

            let $form = $(this),
                attr = $form.serializeArray();

            // Convertir el objeto en un objeto clave-valor
            var formObject: any = {};
            $.each(attr, function (index, field) {
                formObject[field.name] = field.value;
            });

            if (formObject['g-recaptcha-response'] == '') {
                return false;
            }

            let config = { dir: '/action/get-link-alq/', type: 'POST' };

            let $btn_accion = $form.find('#btn-get-link-alq');

            self.addLoadingButton($btn_accion)

            self.utils.jSONInfo(config, formObject, function (data: any) {
                setTimeout(function () {
                    self.removeLoadingButton($btn_accion);
                }, 300)
                self.utils.afterSubmit(data, $form.attr('id'), false);
                self.grecaptchaReset();
            });
        });
    }



    addLoadingButton($btn_action: JQuery<HTMLElement>, text?: string) {
        $btn_action.addClass('disabled');
        let text_org = $btn_action.text();
        $btn_action.data('btn-text', text_org);
        // Crear el elemento HTML del spinner
        let spinner = `
            <div class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>`;
        // Combinar el texto original con el spinner
        let textoConSpinner = `${spinner} ${text || text_org}`;
        // Establecer el nuevo contenido del botón
        $btn_action.html(textoConSpinner);
    }

    removeLoadingButton($btn_action: JQuery<HTMLElement>, text?: string) {
        $btn_action.removeClass('disabled');
        let text_org = $btn_action.data('btn-text');
        $btn_action.html(text || text_org);
    }


    submitRegistrarUsuario() {
        let self = this;
        $('#form-reg-usuario').on('submit', function (e) {
            e.preventDefault();
            e.stopPropagation();

            let $this: any = $(this);
            let $btn_accion = $this.find('.btn-accion')

            if ($btn_accion.hasClass('desactivar')) {
                return false
            }

            if (!self.validarDatosUsuario()) {
                return false
            }

            let attr = $this.serializeArray();

            // Convertir el objeto en un objeto clave-valor
            var formObject: any = {};
            $.each(attr, function (index, field) {
                formObject[field.name] = field.value;
            });

            self.addLoadingButton($btn_accion);

            let config = { dir: $this.attr('action'), type: $this.attr('method') };

            if (formObject['g-recaptcha-response'] == '') {
                return false;
            }

            self.utils.jSONInfo(config, formObject, function (data: any) {
                self.grecaptchaReset();
                self.removeLoadingButton($btn_accion);
                let status = data['user_data']['status'];
                if (!status) {
                    data['mensaje'][0] = data['user_data']['errSTR'];
                    data['status']['error'] = true;
                    self.utils.afterSubmit(data, 'form-reg-usuario', function () {
                        self.utils.closeMsjModal()
                    });
                } else {
                    data['mensaje'][0] = 'Usuario creado exitosamente, Inicia sesión';
                    data['status']['close'] = true;
                    self.utils.afterSubmit(data, 'form-reg-usuario', function () {
                        self.utils.closeMsjModal();
                        $this[0].reset()
                        setTimeout(() => {
                            $('#modal-login').modal('show');
                        }, 400)
                    });
                }
            });
        });
    }

    validarDatosUsuario() {
        let forms = new Forms();
        const camposAValidar: any = [
            { id: 'user-name', validaciones: ['required',] },
            { id: 'user-lastname', validaciones: ['required'] },
            { id: 'user-email', validaciones: ['required'] },
            { id: 'user-password', validaciones: ['required'] },
        ];

        const formularioEsValido = forms.validarCampos('form-reg-usuario', camposAValidar);
        return formularioEsValido
    }



    ForgotListen() {
        let self = this;
        $('#form-forgot').on('submit', function (e) {
            e.preventDefault()

            let $this = $(this),
                $btn_accion = $this.find('.btn-accion'),
                $form = $(this)

            if ($btn_accion.hasClass('desactivar')) {
                return false
            }

            if (!self.validarDatosForgot()) {
                return false
            }

            let textoOriginal = $btn_accion.text();

            self.addLoadingButton($btn_accion, textoOriginal)

            $btn_accion.addClass('disabled');

            let attr = self.serializeObjetc($form),
                config = { dir: $form.attr('action'), type: $form.attr('method') };
            self.utils.jSONInfo(config, attr, function (data: any) {
                self.utils.afterSubmit(data, 'form-forgot', function () {
                    setTimeout(function () { self.utils.closeMsjModal(); }, 1000);
                })
                $btn_accion.removeClass('disabled').html(x_textos['T90-0'])
            });
        });
    }


    validarDatosForgot() {
        let forms = new Forms();
        const camposAValidar: any = [
            { id: 'forgot-email', validaciones: ['required', 'email'] },
        ];

        const formularioEsValido = forms.validarCampos('form-forgot', camposAValidar);
        return formularioEsValido
    }

    serializeObjetc($form: any) {
        let attr = $form.serializeArray();

        // Convertir el objeto en un objeto clave-valor
        var formObject: any = {};
        $.each(attr, function (index, field) {
            formObject[field.name] = field.value;
        });

        formObject['csrf_token'] = this.utils.getCsrfToken();  // Agrega el token CSRF a los datos

        return formObject;
    }

    listenCookies() {
        let self = this;
        if (!_aceptar_cookies) {
            $('#cookies').css('display', 'block');
        }
        $("#aceptar-cookies").on('click', function (event) {
            event.stopPropagation();
            event.preventDefault();
            self.utils.createCookie('aceptar_cookies', "1", 365, Domain);
            $('#cookies').css('display', 'none');
        });
    }

    grecaptchaReset() {
        const captchas = $('.g-recaptcha');
        for (let i = 0; i < captchas.length; i++) {
            grecaptcha?.reset(i);
        }
    }
}

export function waitLangText(callback: Function) {
	if (typeof x_textos !== 'undefined') {
		callback();
	} else {
		setTimeout(() => waitLangText(callback), 100);
	}
}